import { render, staticRenderFns } from "./black.vue?vue&type=template&id=10c1e0b3&"
import script from "./black.vue?vue&type=script&lang=js&"
export * from "./black.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports